import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CdnIcon, QntBadge } from '@shared/ui';
import { ListItemButton, ListItemText } from '@mui/material';
import { useTheme } from '../../../../theme';
import { useIsTablet } from '../../../../utils';
const Item = ({ route, isSelected }) => {
    const { SidebarItem: css } = useTheme('SidebarItem');
    const { t } = useTranslation('Account');
    const isTablet = useIsTablet();
    return (React.createElement(ListItemButton, { selected: isSelected, classes: {
            root: css.sidebarItem,
            selected: css.sidebarItem_selected
        } },
        React.createElement(CdnIcon, { className: css.sidebarItem__icon, icon: route.icon }),
        React.createElement(ListItemText, { classes: { primary: css.sidebarItem__text }, primary: t(route.title) }),
        route.badgeContent > 0 && (React.createElement(QntBadge, { count: route.badgeContent, variant: isTablet ? 'default' : 'invert' }))));
};
export default Item;
